import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../../../../core/services/notification/notification.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TransactionResult } from '../../../../../../core/services/interfaces/transaction-result';
import { INDAManagement } from '../../../Interfaces/INDAManagement';
import { IEvidencesNDAs } from '../../../Interfaces/IEvidences';
import { IEvidenceTypes } from '../../../Interfaces/IEvidenceTypes';
import { SitesService } from '../../../services/sites-services';
import { UploadFileService } from '../../../services/upload-file.service';
import { NDAManagementService } from '../../../services/ndaManagement-services';
import { EvidenceTypesService } from '../../../services/evidencetypes-services';
import { TranslateService } from '../../../../../../core/services/translate-service';
import { TranslateApplicationService } from '../../../../../../core/translate/translate-application-service';
import { PropertiesService } from '../../../services/properties-services';
import { IProperties } from '../../../Interfaces/IProperties';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Integer } from 'aws-sdk/clients/apigateway';
import { listLazyRoutes } from '@angular/compiler/src/aot/lazy_routes';

@Component({
	selector: 'evidenceNDA-detail',
	templateUrl: 'evidenceNDA-detail.component.html',
})
export class EvidenceNDADetailComponent implements OnInit {
	formGroup: FormGroup;
	loading = false;
	blockButton = true;

	selectedFiles: FileList;
	countEvidences: Integer = 0;
	ndaManagement: INDAManagement = {
		pkndamanagment: 0,
		fkndamanagment: 0,
		ndamanagment: '',
		fkndatype: 0,
		ndatypename: '',
		available: false,
		creationdate: new Date(),
		strcreationdate: '',
		fkemployeecreator: 0,
		lastupdated: new Date(),
		strlastupdated: '',
		fkemployeeupdater: 0,
		employeecreatorname: '',
		employeeupdatername: '',
		username: '',
		fksite: 0,
	};
	evidenceNDAs: IEvidencesNDAs = {
		pkevidencenda: 0,
		evidencenda: '',
		fkndamanagement: 0,
		creationdate: new Date(),
		strcreationdate: '',
		fkemployeecreator: 0,
		lastupdated: new Date(),
		strlastupdated: '',
		fkemployeeupdater: 0,
		available: false,
		username: '',
		usernamecreator: '',
		fksite: 0,
		nameinbucket: '',
	};
	BUCKET: string = '';
	REGION: string = '';
	FOLDER: string = '';
	NAME: string = '';
	fileType: number = 0;
  NDAManagementInfo: IEvidencesNDAs[] = [];
  validExtensionFile: boolean = false;

	constructor(
		public dialogRef: MatDialogRef<EvidenceNDADetailComponent>,
		@Inject(MAT_DIALOG_DATA) public data: INDAManagement,
		public notificationService: NotificationService,
		public translateService: TranslateService,
		public siteService: SitesService,
		public uploadFileService: UploadFileService,
		public formBuilder: FormBuilder,
		public translate: TranslateApplicationService,
		public ndaManagementService: NDAManagementService,
		public propertyService: PropertiesService,
		public evidenceTypeService: EvidenceTypesService,
		public httpClient: HttpClient,
	) {
		this.formGroup = this.formBuilder.group({
			pkEvidenceNDA: [
				data.pkndamanagment == null ? 0 : data.pkndamanagment,
			],
			pkndamanagment: [
				data.pkndamanagment == null ? 0 : data.pkndamanagment,
			],
			ndamanagment: [
				data.ndamanagment,
				[
					Validators.required,
					Validators.maxLength(80),
					Validators.pattern('.*[^ ].*'),
				],
			],
			fkndatype: [
				data.fkndatype == 0 ? null : data.fkndatype,
				Validators.required,
			],
		});
		this.evidenceNDAs.pkevidencenda =
			this.formGroup.controls.pkEvidenceNDA.value;
	}
	ngOnInit(): void {	
	}

	Upload() {
		this.loading = true;
		if (this.formGroup.controls.pkndamanagment.value == 0) {
			this.ndaManagementService.CreateNDAManagement(this.data).subscribe(
				(result: TransactionResult<INDAManagement[]>) => {
					this.loading = false;
					if (result.data.length > 0) {
						this.formGroup.controls.pkndamanagment.setValue(
							result.data[0].pkndamanagment,
						);
						for (var i = 0; i < this.selectedFiles.length; i++) {
							const file = this.selectedFiles.item(i);
							var filename = file.name.substr(file.name.lastIndexOf('.') + 1);
							this.loading = true;
							this.evidenceTypeService.GetEvidenceTypeByExtensionFile('.' + filename).subscribe(
								(result: TransactionResult<IEvidenceTypes[]>) => {
									this.loading = false;
									if (result.success) {
									if (result.data[0] != null) {
										this.ExtensionFileSuccess(result, file);
									} else {
										this.loading = false;
										this.Alert("Warning", "EVIDENCETYPES.ExtensionError");
									}
									}
									else{
										this.ErrorAlert(result.message);
									}
								},
								(error: any) => { this.ErrorAlert(error); this.loading = false; },
							);
						}
					}
				},
				(error) => {
					this.ErrorAlert(error);
					this.loading = false;
				});
		} 
		else {
			for (var i = 0; i < this.selectedFiles.length; i++) {
				const file = this.selectedFiles.item(i);
				var filename = file.name.substr(file.name.lastIndexOf('.') + 1);
				this.evidenceTypeService.GetEvidenceTypeByExtensionFile('.' + filename).subscribe(
					(result: TransactionResult<IEvidenceTypes[]>) => {
					if (result.success) {
						if (result.data[0] != null) {
							this.ExtensionFileSuccess(result, file);
							this.loading = false;
						} 
						else {
							this.loading = false;
							this.Alert("Warning", "EVIDENCETYPES.ExtensionError");
						}
					}
					else{
						this.ErrorAlert(result.message);
						this.loading = false;
					}
					},
					(error: any) => { this.ErrorAlert(error); this.loading = false; },
				);
			}
		}
	}

	ExtensionFileSuccess(
		result: TransactionResult<IEvidenceTypes[]>,
		file: File,
	) {
		this.loading = true;
		this.fileType = result.data[0].pkevidencetype;
		this.propertyService.GetPropertyByName('BUCKET_APPLICATION_PATH').subscribe(
			(result: TransactionResult<IProperties[]>) => {
				this.loading = false;
				if (result.success) {
					this.FOLDER = result.data[0].propertyvalue;
					this.NAME = this.GetUniqueId(10) + '.' + file.name.split('.')[1];
					this.loading = true;
					this.propertyService.GetPropertyByName('S3_Bucket_PRESIGNED_URL_API').subscribe(
						(presignedAPIURLResult: TransactionResult<IProperties[]>) => {
							this.loading = false;
							if (presignedAPIURLResult.success) {
								this.EvidenceDataConfiguration(
									file,
									presignedAPIURLResult,
								);
							}
							else{
								this.AlertProperties('Error','WARNINGS.Property_not_found','S3_Bucket_PRESIGNED_URL_API');
							}
						},
						(error: any) => { this.ErrorAlert(error); this.loading = false; },
					);
				} 
				else{
					this.AlertProperties('Error','WARNINGS.Property_not_found','BUCKET_APPLICATION_PATH');
				}
			},
			(error: any) => { this.ErrorAlert(error); this.loading = false; },
		);
	}

	EvidenceDataConfiguration(
		file: File,
		presignedAPIURLResult: TransactionResult<IProperties[]>,
  	) {
		this.loading = true;
		this.uploadFileService.UploadPreSignedUrl(
			this.FOLDER + "NDATemplates/"+ file.name + this.NAME,
			file.type,
			presignedAPIURLResult.data[0].propertyvalue,).subscribe(
				(result: TransactionResult<any>) => {
					this.loading = false;
					if (result.success) {
						var { url, formData } = this.ConfigureIncident(result,file,);
						this.httpClient.post(url, formData, {
								observe: 'events',
								reportProgress: true,
							}).subscribe(
								(result) => {
								this.loading = false;
								if (result.type === HttpEventType.UploadProgress) {
								} else if (result.type == HttpEventType.Response) {
									this.loading = true;
									this.Alert("Success", "NDAs.File_uploaded");

									this.evidenceNDAs.evidencenda = file.name;
									this.evidenceNDAs.fkndamanagement = this.formGroup.controls.pkndamanagment.value;
									this.evidenceNDAs.nameinbucket = "NDATemplates/" +file.name + this.NAME;
									this.AddEvidence();
								}
							},
							(error) => {
								this.ErrorAlert(error);
								this.loading = false;
							});
					}
					else{
						this.ErrorAlert(result.message);
					}
				},
				(error) => {
					this.ErrorAlert(error);
					this.loading = false;
				}
			);
	}

	public ConfigureIncident(result: TransactionResult<any>, file: File) {
		this.loading = true;
		var url = result.data.url;
		const formData = new FormData();
		var a = result.data.fields['Content-Type'];
		formData.append('Content-Type', result.data.fields['Content-Type']);
		formData.append('key', result.data.fields.key);
		formData.append('AWSAccessKeyId', result.data.fields.AWSAccessKeyId);
		formData.append('policy', result.data.fields.policy);
		formData.append('signature', result.data.fields.signature);
		formData.append(
			'x-amz-security-token',
			result.data.fields['x-amz-security-token'],
		);
		formData.append('file', file);
		this.loading = false;
		return { url, formData };
	}

  	GetUniqueId(parts: number): string {
		this.loading = true;
		const stringArr = [];
		for (let i = 0; i < parts; i++) {
			const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
			stringArr.push(S4);
		}
		this.loading = false;
		return stringArr.join('-');
	}

	UpdateEvidence() {
		this.loading = true;
		this.ndaManagementService.UpdateEvidenceNDA(this.evidenceNDAs).subscribe(
			(result: TransactionResult<boolean>) => {
				this.loading = false;
				if (result.success) {
					this.Alert("Success", "COMPLETE");
					this.dialogRef.close(true);
				}
				else{
					this.ErrorAlert(result.message);
				}
			},
			(error: any) => { this.ErrorAlert(error); this.loading = false; },
		);
	}

	AddEvidence() {
		this.loading = true;
		if (this.formGroup.controls.pkEvidenceNDA.value == 0) {
			this.ndaManagementService.CreateEvidenceNDA(this.evidenceNDAs).subscribe(
				(result: TransactionResult<boolean>) => {
					this.loading = false;
					if (result.success) {
						this.Alert("Success", "COMPLETE");
						this.dialogRef.close(true);
					}
					else{
						this.ErrorAlert(result.message);
					}
				},
				(error: any) => { this.ErrorAlert(error); this.loading = false; },
			);
		} else {
			this.ndaManagementService.UpdateEvidenceNDA(this.evidenceNDAs).subscribe(
				(result: TransactionResult<boolean>) => {
					this.loading = false;
					if (result.success) {
						this.Alert("Success", "COMPLETE");
						this.dialogRef.close(true);
					}
					else{
						this.ErrorAlert(result.message);
					}
				},
				(error: any) => { this.ErrorAlert(error); this.loading = false; },
			);
		}
  	}

	SelectFile(event) {
		this.loading = true;
    	this.selectedFiles = event.target.files;
    	this.ValidateExtensionFiles();
		this.loading = false;
	}

	Close() {
		this.dialogRef.close(false);
	}

	Alert(title: string, message: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: this.translate.TranslateKey(message),
			shown: true,
		});
	}

	ErrorAlert(message: any) {
		this.notificationService.AddAlert({
		  icon: 'all_inbox',
		  title: 'Error',
		  message: message,
		  shown: true,
		});
  	}

	AlertProperties(title: string, message: string, property: string){
	this.notificationService.AddAlert({
		icon: 'all_inbox',
		title: title,
		message: this.translate.TranslateKey(message) + ': ' + property,
		shown: true
	});
	}
  
	ValidateExtensionFiles() {
		this.validExtensionFile = true;
		for (var i = 0; i < this.selectedFiles.length; i++) {
			const file = this.selectedFiles.item(i);
			if (file.type != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
				this.validExtensionFile = false;
				break;
			}
		}
	}
}
